
import { useBaseLicenseData } from './license/useBaseLicenseData';
import { useLicenseKeys } from './license/useLicenseKeys';
import { useDomains } from './license/useDomains';
import { useSuperAdminLicenses } from './license/useSuperAdminLicenses';
import { useResellerPlans } from './license/useResellerPlans';
import { useState, useEffect } from 'react';
import { User } from '@/types/userRole';
import { useMasterLicenseReferralBank } from './useMasterLicenseReferralBank';
import { getPendingOrdersCount } from '@/components/masterlicense/sales/SalesDataConnection';

export const useMasterLicense = () => {
  const baseData = useBaseLicenseData();
  const [user, setUser] = useState<User | null>(null);
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);
  
  const {
    licenseKeys,
    setLicenseKeys,
    domains,
    setDomains,
    superAdminLicenses,
    setSuperAdminLicenses,
    filteredLicenseKeys,
    isLoading,
    searchQuery,
    setSearchQuery,
    activeTab,
    setActiveTab,
    handleLogout,
    toast,
    navigate
  } = baseData;
  
  const referralBankData = useMasterLicenseReferralBank();
  
  useEffect(() => {
    // Mock user data for demo purposes
    setUser({
      id: "master-admin-1",
      name: "Master Admin",
      email: "master@referme.site",
      role: "masterAdmin",
      createdAt: new Date(),
      isMasterAdmin: true
    });
    
    // Fetch the pending orders count
    const fetchPendingOrdersCount = async () => {
      try {
        const count = await getPendingOrdersCount();
        setPendingOrdersCount(count);
      } catch (error) {
        console.error("Error fetching pending orders count:", error);
      }
    };
    
    fetchPendingOrdersCount();
    
    // Refresh the count every minute
    const intervalId = setInterval(fetchPendingOrdersCount, 60000);
    
    return () => clearInterval(intervalId);
  }, []);
  
  const licenseKeyOps = useLicenseKeys(licenseKeys, setLicenseKeys);
  const domainOps = useDomains(domains, setDomains, licenseKeys, setLicenseKeys);
  const superAdminOps = useSuperAdminLicenses(superAdminLicenses, setSuperAdminLicenses, licenseKeys, setLicenseKeys);
  const planOps = useResellerPlans();
  
  return {
    isLoading,
    licenseKeys,
    filteredLicenseKeys,
    domains,
    superAdminLicenses,
    searchQuery,
    setSearchQuery,
    activeTab,
    setActiveTab,
    handleLogout,
    toast,
    navigate,
    user,
    pendingOrdersCount,
    ...licenseKeyOps,
    ...domainOps,
    ...superAdminOps,
    ...planOps,
    ...referralBankData
  };
};
